import React, { type CSSProperties, type ReactNode } from "react";
import { Layout, Grid } from "antd";

export type PagePaddingProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const PagePadding: React.FC<PagePaddingProps> = ({ children, className, style }) => {
  const screens = Grid.useBreakpoint();
  const isLg = screens.lg;

  return (
    <Layout.Content
      className={className}
      style={{
        padding: isLg ? "28px 32px" : "14px 12px",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        width: "100%",
        maxWidth: 1240,
        marginInline: "auto",
        ...style,
      }}
    >
      {children}
    </Layout.Content>
  );
};

export default PagePadding;
